export default {

  CONTENT_TYPE: "Content-Type",

  TRANSFER_ENCODING: "Transfer-Encoding"

}



// WEBPACK FOOTER //
// ./src/headers.js